import { ServiceResponseDTO } from 'typings/dto/service';
import Mapper from './Mapper';
import EnterpriseUtils from 'utils/models/EnterpriseUtils';

export default class ServiceMapper extends Mapper<BusinessService, ServiceResponseDTO> {
  constructor(private currentUserGetter: () => User | null) {
    super({
      includedText: 'included',
      name: 'name',
      notIncludedText: 'notIncluded',
      serviceCategory: 'category',
      servicePackage: 'package',
      technicalName: 'technicalName',
      workEstimation: 'workEstimation',
      tenant: 'tenant',
      isPostWarranty: 'isPostWarranty',
      measurementUnit: 'measurementUnit',
    });
  }

  public responseDTOToModel(dto: ServiceResponseDTO): BusinessService {
    const currentUser = this.currentUserGetter();

    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      workEstimation:
        typeof dto.workEstimation?.durationMinutes === 'number' ? { durationMinutes: dto.workEstimation.durationMinutes! } : undefined,
      isInherited: EnterpriseUtils.isEntityInherited(currentUser, dto),
    };
  }
}
